var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "日期"
    }
  }, [[_c("data-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.formData,
      callback: function callback($$v) {
        _vm.formData = $$v;
      },
      expression: "formData"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "服务器列表"
    }
  }, [_c("server-list", {
    attrs: {
      isCache: "",
      multiple: true,
      all: ""
    },
    model: {
      value: _vm.searchInfo.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "server_id", $$v);
      },
      expression: "searchInfo.server_id"
    }
  })], 1), _c("el-form-item", {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c("el-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: _vm.searchEvent
          }
        }, [_vm._v("查询")])];
      },
      proxy: true
    }])
  })], 1), _c("div", [[_c("el-table", {
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      height: "600",
      border: "",
      "header-cell-style": {
        background: "#eef1f6",
        color: "#606266"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      sortable: "",
      prop: "date_str",
      width: "150",
      label: "日期"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "new_role",
      label: "创角",
      width: "75"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_user",
      label: "付费人数",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_vm._v(" " + _vm._s(row.pay_user) + " (" + _vm._s(row.pay_average) + ") ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "ltv",
      label: "终生ltv",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.ltv) + " (" + _vm._s(scope.row.new_role > 0 ? _vm.cal.toDecimal2(scope.row.ltv / scope.row.new_role) : "0") + ") ")];
      }
    }])
  }), _vm._l(_vm.pageCom, function (item, index) {
    return _c("el-table-column", {
      key: index,
      attrs: {
        label: item,
        width: "150",
        prop: item
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(scope) {
          return [_vm._v(" " + _vm._s(scope.row[item] !== undefined ? scope.row[item] + (scope.row["new_role"] > 0 ? "(" + _vm.toDecimal2(scope.row[item] / scope.row["new_role"]) + ")" : "0") : "-") + " ")];
        }
      }], null, true)
    });
  })], 2)]], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };